/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputGeoTraceStep } from './OutputGeoTraceStep';
import {
    OutputGeoTraceStepFromJSON,
    OutputGeoTraceStepFromJSONTyped,
    OutputGeoTraceStepToJSON,
} from './OutputGeoTraceStep';

/**
 * 
 * @export
 * @interface OutputGeoTraceHypothesis
 */
export interface OutputGeoTraceHypothesis {
    /**
     * 
     * @type {boolean}
     * @memberof OutputGeoTraceHypothesis
     */
    best?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceHypothesis
     */
    cost?: number;
    /**
     * 
     * @type {Array<OutputGeoTraceStep>}
     * @memberof OutputGeoTraceHypothesis
     */
    steps?: Array<OutputGeoTraceStep>;
}

/**
 * Check if a given object implements the OutputGeoTraceHypothesis interface.
 */
export function instanceOfOutputGeoTraceHypothesis(value: object): boolean {
    return true;
}

export function OutputGeoTraceHypothesisFromJSON(json: any): OutputGeoTraceHypothesis {
    return OutputGeoTraceHypothesisFromJSONTyped(json, false);
}

export function OutputGeoTraceHypothesisFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputGeoTraceHypothesis {
    if (json == null) {
        return json;
    }
    return {
        
        'best': json['best'] == null ? undefined : json['best'],
        'cost': json['cost'] == null ? undefined : json['cost'],
        'steps': json['steps'] == null ? undefined : ((json['steps'] as Array<any>).map(OutputGeoTraceStepFromJSON)),
    };
}

export function OutputGeoTraceHypothesisToJSON(value?: OutputGeoTraceHypothesis | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'best': value['best'],
        'cost': value['cost'],
        'steps': value['steps'] == null ? undefined : ((value['steps'] as Array<any>).map(OutputGeoTraceStepToJSON)),
    };
}

